import { type FunctionComponent } from 'react';
import { SvgIcon, type SvgIconProps } from './SvgIcon';

export const LogoutIcon: FunctionComponent<SvgIconProps> = (props) => {
  return (
    <SvgIcon fill="none" height="24" viewBox="0 0 24 24" width="24" {...props}>
      <path
        d="M14.25 15C13.8375 15 13.5 15.3375 13.5 15.75V20.9026L3 19.5901V4.41012L13.5 3.09762V8.25022C13.5 8.66272 13.8375 9.00022 14.25 9.00022C14.6625 9.00022 15 8.66272 15 8.25022V2.25022C15 1.80772 14.61 1.44772 14.16 1.50772L2.16 3.00772C1.785 3.05272 1.5 3.37522 1.5 3.75022V20.2502C1.5 20.6252 1.785 20.9477 2.16 20.9927L14.16 22.4927C14.6025 22.5527 15 22.2002 15 21.7502V15.7502C15 15.3377 14.6625 15 14.25 15Z"
        fill="white"
      />
      <path
        d="M22.2822 11.4674L18.5322 7.71742C18.2397 7.42492 17.7672 7.42492 17.4747 7.71742C17.1822 8.00992 17.1822 8.48242 17.4747 8.77492L19.9421 11.2423H6.74951C6.33701 11.2423 5.99951 11.5798 5.99951 11.9923C5.99951 12.4048 6.33701 12.7423 6.74951 12.7423H19.9421L17.4747 15.2097C17.1822 15.5022 17.1822 15.9747 17.4747 16.2672C17.7672 16.5597 18.2397 16.5597 18.5322 16.2672L22.2822 12.5172C22.5747 12.2247 22.5747 11.7522 22.2822 11.4597V11.4674Z"
        fill="white"
      />
    </SvgIcon>
  );
};
